import { en_US_cpq } from "./en_US_cpq";

export default {
  regiolux: {
    showDebugDrawer: "Show Debug Drawer",
    "previous.configuration": "Previous",
    "next.configuration": "Next",
    "reset.configuration": "Reset Selection",
    "reset.subConfiguration": "Reset Group",
    "bom.header": "Bill of Materials",
    "bom.sum": "Total Items",
    "add.XAS_GERAETETRAEGER": "Add device carriers",
    "add.XAS_FUNKTIONSMODUL": "Add functional module (Optional)",
    "add.XAS_TRAGSCHIENE": "Mounting rail, mounting type and blank cover",
    "add.show_BOM": "Show configuration result",
    addToShoppingCart: "Add to Collection Basket",
    saveConfiguration: "Save Configuration",
    "sidebar.header": "SRT CONFIGURATOR",
    "dialog.requestQuote.open": "Request Quote",
    "dialog.requestQuote.geolocationDE.specialistRetailerText":
      "Please specify the retailer from whom you would like to receive the offer:",
    "dialog.requestQuote.geolocationDE.specialistRetailerName":
      "Specialist retail company",
    "dialog.requestQuote.geolocationDE.specialistRetailerLocation": "Place",
    "dialog.requestQuote.geolocationDE.specialistRetailerContact":
      "Contact person",
    "dialog.requestQuote.geolocationDE.specialistRetailerCustomerNo":
      "Customer number of the authorised distributor (if available)",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerText":
      "Please let us know who your preferred sales partner is:",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerName":
      "Sales partner",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerLocation":
      "Place",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerContact":
      "Contact person",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerCustomerNo":
      "Customer number of the sales partner (if available)",
    "dialog.requestQuote.message": "Message",
    "dialog.requestQuote.email": "Your Email Address",
    "dialog.requestQuote.title": "Salutation",
    "dialog.requestQuote.firstName": "First Name",
    "dialog.requestQuote.lastName": "Last Name",
    "dialog.requestQuote.phoneNumber": "Phone Number",
    "dialog.requestQuote.optionalDetails": "optional Details",
    "dialog.requestQuote.street": "Street / No.",
    "dialog.requestQuote.postcode": "Postcode / City",
    "dialog.requestQuote.company": "Company",
    "dialog.requestQuote.position": "Position",
    "dialog.requestQuote.industry": "Industry",
    "dialog.requestQuote.country": "Country",
    "dialog.requestQuote.mobileNumber": "Mobile",
    "dialog.requestQuote.text.title": "Basket",
    "dialog.requestQuote.description": "Please fill out the form below",
    "dialog.requestQuote.text.cancel": "Back",
    "dialog.requestQuote.text.confirm": "Submit Quote",
    "dialog.requestQuote.dataPrivacy.title": "Privacy policy",
    "dialog.requestQuote.dataPrivacy.text.start":
      "By placing this request, I agree to the saving and use of my data in accordance with the",
    "dialog.requestQuote.dataPrivacy.text.end": "of Regiolux GmbH.",
    "dialog.requestQuote.dataPrivacy.link.text": "privacy policy",
    "dialog.requestQuote.dataPrivacy.link.url":
      "https://www.regiolux.de/en/data-privacy",
    "dialog.requestQuote.emailMarketingConsent.title": "Information",
    "dialog.requestQuote.text.tooltip":
      "Please fill in project description and project location.",
    "tooltip.toConfigure": "Configure",
    "title.configurationFinished":
      "The configuration has been successfully completed.",
    "subItem.property.label.listPrice": "List price",
    "subItem.property.label.totalList": "Sum",
    "item.property.label.totalList": "Sum",
    "toast.requestQuote.error": "Quote could not be requested",
    "additionalQuoteFields.textBlock":
      "The basket is set up for the preparation of quotations for commercial customers via specialist dealers.\nWe will forward your compilation to your specialised trade partner for quotation processing.\n In the “Request a quote” section, you will then need to enter the details of your authorised dealer.",

    "label.additionalQuoteFields.projectDescription": "Project Description",
    "label.additionalQuoteFields.projectLocation": "Project Location",
    "item.property.label.note": "Note",
    "button.downloadShoppingCart.label": "Download Collection Basket",
    "button.finishConfiguration.label": "Finish Configuration",
    "button.showBOM.label": "Show configuration result",
    "button.showBOM.disabledTooltip": "Configuration is incomplete",
    "tooltip.configurationIncomplete": "Configuration is incomplete",
    "tooltip.noUserSessionId": "No valid user session found",
  },
  CPQ: {
    ...en_US_cpq.CPQ,
    "cart.title": "Basket",
    "cart.label.emptyCart": "Your Collection Basket is empty",
  },
};
